import styled from '@emotion/styled'

import { InformationFillIcon } from '@arcade/web/icons/react'

import { spacing } from '../../theme'

export interface ArcadeTooltipProps {
  onClick: () => void
  ariaLabel: string
}

const Tooltip = styled.span`
  height: ${spacing.l};
  outline: none;

  ${({ theme }) => theme.selectors.keyboard} &:focus {
    outline: 0.0938rem solid ${({ theme }) => theme.arcadeColors.component.inputLabelDefault};
    border-radius: ${spacing.xxs};
  }
`

export default (props: ArcadeTooltipProps) => (
  <Tooltip onClick={props.onClick} tabIndex={0} data-testid="tooltip">
    <InformationFillIcon size={24} aria-label={props.ariaLabel} aria-hidden={false} />
  </Tooltip>
)
